module.exports = __webpack_public_path__ + "static/media/stopbullying.2a7ea237.png";